import { render, staticRenderFns } from "./check-goods.vue?vue&type=template&id=315bd9ce&scoped=true&"
import script from "./check-goods.vue?vue&type=script&lang=js&"
export * from "./check-goods.vue?vue&type=script&lang=js&"
import style0 from "./check-goods.vue?vue&type=style&index=0&id=315bd9ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315bd9ce",
  null
  
)

export default component.exports